import { render, staticRenderFns } from "./defaultSetting.vue?vue&type=template&id=03c0d7f7"
import script from "./defaultSetting.vue?vue&type=script&lang=js"
export * from "./defaultSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports